import { Box, Button, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import approval from "../asset/images/approval_1.png";
import "./postbid-modern.css";

function UpdateBid({ bidData }) {
  const [submitted, setSubmitted] = useState(false);
  const [phase, setPhase] = useState("preparing");
  const [mediaProgress, setMediaProgress] = useState(0);
  const [error, setError] = useState("");
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    let cancelled = false;
    let verifyTimer = null;
    let verifyAttempts = 0;

    const token = Cookies.get("token");
    let imagesSize = bidData.imagesSize || "";
    let allImageUrl = bidData.images || "";
    let allVideoUrl = bidData.video || "";
    let allpublicid = bidData.publicid || "";
    const newBidImages = Array.isArray(bidData.bidImages) ? bidData.bidImages : Object.values(bidData.bidImages || {});

    const isSavedOnServer = (serverBid) => {
      if (!serverBid) return false;
      const normalize = (value) => (value == null ? "" : String(value).trim());
      const normalizeRichText = (value) => normalize(value)
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, " ")
        .trim();

      const contentSaved = normalize(serverBid.title) === normalize(bidData.title)
        && normalize(serverBid.area) === normalize(bidData.area)
        && normalize(serverBid.skills).replace(/,+$/, "") === normalize(bidData.skills).replace(/,+$/, "")
        && normalizeRichText(serverBid.description) === normalizeRichText(bidData.description);

      if (!contentSaved) return false;

      // Only verify deadline when the user actually selected a new duration.
      // A small tolerance avoids false negatives caused by serialization/rounding.
      if (bidData.durationChanged) {
        const serverDeadline = Number(serverBid.deadline);
        const requestedDeadline = Number(bidData.deadline);
        if (!Number.isFinite(serverDeadline) || !Number.isFinite(requestedDeadline)) return false;
        return Math.abs(serverDeadline - requestedDeadline) <= 5000;
      }

      return true;
    };

    const verifySaved = () => axios.get(
      `${process.env.React_APP_BACKEND_URL}/api/getabid?id=${bidData.id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    ).then((res) => isSavedOnServer(res.data?.Bid?.[0])).catch(() => false);

    const markSuccess = () => {
      if (cancelled) return;
      if (verifyTimer) clearInterval(verifyTimer);
      setSubmitted(true);
      setPhase("done");
      setError("");
    };

    const startVerification = () => {
      verifyTimer = setInterval(async () => {
        verifyAttempts += 1;
        const saved = await verifySaved();
        if (saved) {
          markSuccess();
        } else if (verifyAttempts >= 12) {
          clearInterval(verifyTimer);
          verifyTimer = null;
        }
      }, 2500);
    };

    const uploaders = newBidImages.map((file) => {
      if (!file || !file.type) return Promise.resolve();
      const type = file.type;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", process.env.React_App_CLOUDINARY_UPLOAD_PRESET);
      formData.append("api_key", process.env.React_App_CLOUDINARY_API);
      formData.append("timestamp", (Date.now() / 1000) | 0);
      return axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.React_App_CLOUDINARY_CLOUD_NAME}/upload`,
        formData,
        {
          onUploadProgress: (data) => {
            if (data.total) setMediaProgress(Math.round((data.loaded / data.total) * 100));
          },
          headers: { "X-Requested-With": "XMLHttpRequest" },
        }
      ).then((response) => {
        const data = response.data;
        imagesSize += `${data.bytes},`;
        allpublicid += `${data.public_id},`;
        if (type.includes("video")) allVideoUrl += `${data.secure_url},`;
        else allImageUrl += `${data.secure_url},`;
      });
    });

    let date = new Date(parseInt(bidData.deadline.toString(), 10));
    date = new Date(date.getTime() + 10 * 60000);
    const mins = date.getMinutes() < 10 ? date.getMinutes() + 10 : date.getMinutes();

    const payload = {
      title: bidData.title,
      area: bidData.area,
      skills: bidData.skills,
      notes: bidData.notes || "",
      description: bidData.description,
      images: allImageUrl.toString(),
      video: allVideoUrl.toString(),
      deadline: bidData.deadline.toString(),
      length1: bidData.durationChanged ? Number(bidData.length) : bidData.length,
      status: true,
      extra: `${Cookies.get("name")} ${Cookies.get("last_name").charAt(0)}.`,
      publicid: allpublicid,
      size: bidData.size,
      imagesSize,
      dateDeadline:
        `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()} ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${mins}:00`,
    };

    setPhase(newBidImages.length ? "uploading" : "saving");
    Promise.all(uploaders)
      .then(() => {
        if (cancelled) return;
        setPhase("saving");
        payload.images = allImageUrl.toString();
        payload.video = allVideoUrl.toString();
        payload.publicid = allpublicid;
        payload.imagesSize = imagesSize;
        startVerification();
        return axios.put(
          `${process.env.React_APP_BACKEND_URL}/api/updateWholeBid?id=${bidData.id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      })
      .then((response) => {
        if (response) markSuccess();
      })
      .catch(async (err) => {
        console.log(err);
        const saved = await verifySaved();
        if (saved) markSuccess();
        else if (!cancelled) {
          if (verifyTimer) clearInterval(verifyTimer);
          setPhase("error");
          setError("לא התקבל אישור שהעריכה נשמרה. המכרז לא נשלח שוב אוטומטית, כדי למנוע עדכון כפול.");
        }
      });

    return () => {
      cancelled = true;
      if (verifyTimer) clearInterval(verifyTimer);
    };
  }, [bidData]);

  if (submitted) {
    return (
      <Box className="bidit-success-card" sx={{ textAlign: "center", fontFamily: `${process.env.REACT_APP_FONT}` }}>
        <Typography variant="h3" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>המכרז עודכן בהצלחה</Typography>
        <img src={approval} alt="אישור" style={{ width: "auto", display: "block", margin: "12px auto" }} />
        <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#607487" }}>השינויים נשמרו ואין צורך לרענן את הדף.</Typography>
        <Button component={NavLink} to="/" variant="contained" className="bidit-primary-button" sx={{ mt: 2, fontFamily: `${process.env.REACT_APP_FONT}` }}>חזרה למסך הבית</Button>
      </Box>
    );
  }

  return (
    <Box className="bidit-update-status" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      {phase !== "error" && <CircularProgress size={38} />}
      <Typography variant="h6" className="bidit-update-status-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 2 }}>
        {phase === "uploading" ? "מעלים את המדיה החדשה..." : phase === "saving" ? "שומרים את השינויים במכרז..." : phase === "error" ? "לא התקבל אישור שמירה" : "מכינים את העדכון..."}
      </Typography>
      <Typography className="bidit-update-status-text" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
        {phase === "uploading" && mediaProgress > 0 ? `העלאה: ${mediaProgress}%` : phase === "error" ? error : "אין צורך לרענן את הדף. ברגע שהשרת יאשר את השמירה תקבלו חיווי כאן."}
      </Typography>
      {phase === "error" && <Button component={NavLink} to="/" variant="outlined" className="bidit-secondary-button" sx={{ mt: 2 }}>חזרה למסך הבית</Button>}
    </Box>
  );
}

export default UpdateBid;
